module.exports = __webpack_public_path__ + "img/le-mans-logo-icon.d65b5eb9.webp";